//
// client-exceptions-app.js
//
// Copyright (c) 2015 by Curalate, Inc.
//

((() => {
    angular.module('curalate').factory('CLIENT_EXCEPTIONS_UTILS', ['$location', $location => ({
        getPageParams() {
            return $location.search();
        },

        setPageParam(page) {
            $location.search('page', page).replace();
        },

        setViewParam(view) {
            $location.search('view', view);
        },

        setTypeParam(type) {
            $location.search('type', type);
        },

        setDateParam(start, end) {
            $location.search('start', start || null);
            $location.search('end', end || null);
        },

        setSortByParam(sortBy, sortReverse) {
            $location.search('sortBy', sortBy || null);
            $location.search('sortReverse', sortReverse || null);
        },

        setFilterParam(filter) {
            $location.search('filter', filter);
        },

        viewNames: {
            summary: {
                name: 'Client Exceptions',
            },
            details: {
                name: 'Client Exception Detail',
            },
        },
    })]).filter('encodeURIComponent', () => // Shamelessly borrowed and adapted from https://github.com/sparkalow/angular-truncate/blob/master/src/truncate.js
    window.encodeURIComponent).filter('lines', () => (input, lineCount) => {
        if (isNaN(lineCount)) return input;
        if (lineCount <= 0) return '';
        if (input) {
            const inputlineCount = input.split(/\n+/);
            if (inputlineCount.length > lineCount) {
                input = `${inputlineCount.slice(0, lineCount).join('\n')}…`;
            }
        }
        return input;
    });
}))();
